/**
 * @memberOf loavies.models.base
 * @constructor
 */

export class QueryModel {
  constructor() {
  }
  /**
   * @param {Object} data
   * @param {string} prefix
   */
  setDataFilter(data, prefix) {
    for (const key in data) {
      this[prefix + key] = data[key]
    }
  }
}
